import { navItems } from "@/utils/nav-items";
import { Stack } from "@mui/material";
import { HeaderMenuDropdown } from "../HeaderMenuDropdown";
import { HeaderMenuItem } from "../HeaderMenuItem";

export function HeaderMenu() {
  return (
    <Stack sx={{ flexDirection: "row", display: { xs: "none", lg: "flex" } }}>
      {navItems.map((navItem) =>
        navItem.subMenu ? (
          <HeaderMenuDropdown key={navItem.id} navItem={navItem} />
        ) : (
          <HeaderMenuItem key={navItem.id} navItem={navItem} />
        )
      )}
    </Stack>
  );
}
